import React from 'react';
import {FaGithub, FaLinkedin} from "react-icons/fa";
import {GrMail} from "react-icons/gr";
import {SiLeetcode} from "react-icons/si"

const Footer = () => {
  return (
    <footer>
      <h4>Developed by Pradeepika Nori</h4>
      <h4>Copyright &copy; 2025 PN</h4>
      <div className='footerLinks'>
        <a href="https://github.com/PraaNori" target='_blank'><FaGithub/></a>
        <a href="https://www.linkedin.com/in/pradeepika-nori/" target='_blank'><FaLinkedin/></a>
        <a href='mailTo:pradeepika.nori@gmail.com' target='_blank'><GrMail/></a>
        <a href="https://leetcode.com/u/pra_nori/" target="_blank"><SiLeetcode/></a>
      </div>
    </footer>
  )
}

export default Footer